import { render, staticRenderFns } from "./FolderSettingsPublications.vue?vue&type=template&id=20790764"
import script from "./FolderSettingsPublications.vue?vue&type=script&lang=js"
export * from "./FolderSettingsPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20790764')) {
      api.createRecord('20790764', component.options)
    } else {
      api.reload('20790764', component.options)
    }
    module.hot.accept("./FolderSettingsPublications.vue?vue&type=template&id=20790764", function () {
      api.rerender('20790764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/folders/FolderSettingsPublications.vue"
export default component.exports